import { createAction, createReducer } from "redux-act";
import produce from "immer";

import { reducerRegistry } from "../reducerRegistry";
import { LayerInfo } from "../../interfaces/resourceInfo";

export const reducerName = "tempLayer";

export type TempLayerState = {
  sourceName: string;
  layerInfo: LayerInfo | null;
  error?: Error;
};

const initialState: TempLayerState = {
  sourceName: "",
  layerInfo: null,
  error: null,
};

export const setTempLayerInfo = createAction<LayerInfo>("tempLayer/setTempLayerInfo");

export const setTempLayerSourceName = createAction<string>("tempLayer/setTempLayerSourceName");

export const setTempLayerError = createAction<Error>("tempLayer/setTempLayerError");

export const reducer = createReducer({}, initialState);

reducer.on(
  setTempLayerSourceName,
  produce((state: TempLayerState, sourceName) => {
    state.sourceName = sourceName;
  }),
);

reducer.on(
  setTempLayerInfo,
  produce((state: TempLayerState, layerInfo) => {
    state.layerInfo = layerInfo;
  }),
);

reducer.on(
  setTempLayerError,
  produce((state: TempLayerState, error) => {
    state.error = error;
  }),
);

reducerRegistry.register(reducerName, reducer);
